export default (({
  fluid,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  screenClass,
  containerWidths,
  gutterWidth,
  moreStyle
}) => {
  const styles = {
    boxSizing: 'border-box',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: gutterWidth / 2,
    paddingRight: gutterWidth / 2,
    maxWidth: null
  };

  if (fluid && !xs && !sm && !md && !lg && !xl) {
    return { ...styles, ...moreStyle };
  }
  const [xsWidth, mdWidth, lgWidth, xlWidth, xxlWidth] = containerWidths;

  if (screenClass === 'xs' && xsWidth && !xs) {
    styles.maxWidth = xsWidth;
  }

  if (screenClass === 'sm' && xsWidth && !sm) {
    styles.maxWidth = xsWidth;
  }

  if (screenClass === 'md' && mdWidth && !md) {
    styles.maxWidth = mdWidth;
  }

  if (screenClass === 'lg' && lgWidth && !lg) {
    styles.maxWidth = lgWidth;
  }

  if (screenClass === 'xl' && xlWidth && !xl) {
    styles.maxWidth = xlWidth;
  }

  if (screenClass === 'xxl' && xxlWidth && !xxl) {
    styles.maxWidth = xxlWidth;
  }

  return { ...styles, ...moreStyle };
});

export const getAfterStyle = () => ({
  display: 'table',
  clear: 'both'
});